import { createRouter, createWebHistory } from 'vue-router';
import cookieManager from '@/store/cookieManager';

/*
add here guards to disable accesess to routers if user is not logged in
example here https://medium.com/js-dojo/how-to-implement-route-guard-in-vue-js-9929c93a13db
*/
function requireCookie(to, from, next) {
  const hasAuth = cookieManager.get('Authorization') != null;
  const hasOtpVerified = cookieManager.hasOtpVerified();

  if (!hasAuth) {
    next({ name: 'Login' });
    return;
  }

  if (!hasOtpVerified && to.name !== 'VerifyOTP') {
    next({ name: 'VerifyOTP' });
    return;
  }

  if (hasOtpVerified && to.name === 'VerifyOTP') {
    next({ name: 'Home' });
    return;
  }

  next();
}
const routes = [
  {
    path: '/',
    name: 'Start',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/update-expired-password',
    name: 'UpdateExpiredPassword',
    component: () => import('@/views/UpdateExpiredPassword.vue'),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
  },
  {
    path: '/check-email',
    name: 'CheckEmail',
    component: () => import('@/views/CheckEmail.vue'),
  },
  {
    path: '/forgot-password/:token/',
    name: 'ForgotPasswordConfirm',
    component: () => import('@/views/ForgotPasswordConfirm.vue'),
  },
  {
    path: '/verify-otp',
    name: 'VerifyOTP',
    component: () => import('@/views/VerifyOTP.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: () => import('@/views/UserProfile.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/control-panel',
    name: 'ControlPanel',
    component: () => import('@/views/ControlPanel.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/dashboards',
    name: 'Dashboards',
    component: () => import('@/views/dashboards/Dashboard.vue'),
    beforeEnter: requireCookie
  },
  {
    path: '/studies',
    name: 'StudyList',
    component: () => import('@/views/StudyList.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/studies/:id',
    name: 'VisualizeStudyTree',
    component: () => import('@/views/VisualizeStudyTree.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/audit-trail',
    name: 'AuditTrail',
    component: () => import('@/views/audits/AuditTrail.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/audit-users',
    name: 'AuditUsers',
    component: () => import('@/views/audits/AuditUsers.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/audit-studies',
    name: 'AuditStudies',
    component: () => import('@/views/audits/AuditStudies.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/audit-ai',
    name: 'AuditAi',
    component: () => import('@/views/audits/AuditAi.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/inbox',
    name: 'Inbox',
    component: () => import('@/views/Inbox.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/library',
    name: 'Library',
    component: () => import('@/views/Library.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/library/edit/:id',
    name: 'EditData',
    component: () => import('@/views/files/EditData.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/library/edit-files',
    name: 'BulkEditData',
    component: () => import('@/views/files/BulkEditData.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/library/upload-files',
    name: 'UploadFiles',
    component: () => import('@/views/files/UploadFiles.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/library/preclassification',
    name: 'Preclassification',
    component: () => import('@/views/files/Preclassification.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/milestones',
    name: 'milestones',
    component: () => import('@/views/Milestones.vue'),
    beforeEnter: requireCookie,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
